
export async function checkIfImageLoads(src: string): Promise<boolean> {
    return new Promise(resolve => {
        const image = new Image();
        image.addEventListener('load', () => resolve(true));
        image.addEventListener('error', () => {
            resolve(false);
        });
        image.src = src;
    });
}
